export const isInStock = (p) => (p?.stock ?? 0) > 0;

// Stable: in-stock products first, out-of-stock at the end, original order kept.
export const inStockFirst = (list) => {
  const inS = [], outS = [];
  (list || []).forEach((p) => (isInStock(p) ? inS : outS).push(p));
  return inS.concat(outS);
};
